














import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';

@Component({
  name: 'GlobalProgress',
})
export default class extends Vue {
  get active() {
    return AppModule.progress.active;
  }

  get bufferValue() {
    return AppModule.progress.bufferValue;
  }

  get color() {
    return AppModule.progress.color;
  }

  get indeterminate() {
    return AppModule.progress.indeterminate;
  }

  get stream() {
    return AppModule.progress.bufferValue < 100;
  }

  get value() {
    return AppModule.progress.value;
  }
}
